import { useEffect, useState } from "react";

import { getScorer } from "../scoring/singleton";
import type { WasmScorer } from "../scoring/wasm-scorer";

export type ScorerState =
  | { readonly kind: "loading" }
  | { readonly kind: "ready"; readonly scorer: WasmScorer }
  | { readonly kind: "error"; readonly error: Error };

/**
 * React hook that resolves the singleton `WasmScorer`. The first call on
 * a page fetches `cogcoin_scoring.wasm` + `cgsm_blob.bin` and pays the
 * ~35 MB cost; later calls re-use the cached scorer instantly.
 */
export function useScorer(): ScorerState {
  const [state, setState] = useState<ScorerState>({ kind: "loading" });

  useEffect(() => {
    let cancelled = false;
    getScorer().then(
      (scorer) => {
        if (!cancelled) setState({ kind: "ready", scorer });
      },
      (err: unknown) => {
        if (cancelled) return;
        const error = err instanceof Error ? err : new Error(String(err));
        setState({ kind: "error", error });
      },
    );
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
